import { memo } from 'react';

interface ComboHeaderProps {
  comboName: string;
}

const ComboHeader = memo(({ comboName }: ComboHeaderProps) => (
  <div>
    <span className="combo-subtitle">Combo {comboName}</span>
  </div>
));

ComboHeader.displayName = 'ComboHeader';

export default ComboHeader;
